// extracted by mini-css-extract-plugin
module.exports = {"root":"BackButton_root__HHX2K","icon":"BackButton_icon__L1Jje","useFade-fadeIn":"BackButton_useFade-fadeIn___B7VE","useFade-fadeOut":"BackButton_useFade-fadeOut__rh_mW"};